import React, { useRef } from "react"
import contact from "../../assets/contact.png"
import "./Contact.css"
import emailjs from '@emailjs/browser';
import LinkedIn from '../../assets/linkedIn.webp';
import Github from '../../assets/github.png';

const Contact = () => {

  const openLinkedIn = () => {
    var url = 'https://www.linkedin.com/in/bhumikavasanta/';
    var newWindow = window.open(url, '_blank');

    // Focus the new tab (optional)
    if (newWindow) {
      newWindow.focus();
    }
  };
  const openGitHub = () => {
    var url = 'https://github.com/bhumikavasanta';
    var newWindow = window.open(url, '_blank');

    if (newWindow) {
      newWindow.focus();
    }
  };
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_749mrpd', 'template_2ea7427', form.current, 'X7FbFTo8swJPc9QiZ')
      .then((result) => {
        console.log(result.text);
        alert('Email Sent');
        e.target.reset();
      }, (error) => {
        console.log(error.text);
      });
  };
  return (
    <>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h1>Contact With Me</h1>
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box'>
                <div>
                  <img className='img' src={contact} alt='Contact' />
                </div>
                <div className='details'>
                  <h1>Bhumika Vasanta</h1>
                  <p>Phone: +91 6263377897</p>
                  <p>Email: bhumikavasanta2460@gmail.com</p> <br />
                  <span>FIND ME</span>
                  <div className='button f_flex'>
                      <img onClick={openLinkedIn} className='iconImgLinkedIn' src={LinkedIn} alt="LinkedIn" />
                      <img onClick={openGitHub} className='iconImgGithub' src={Github} alt="Github" />
                  </div>
                </div>
              </div>
            </div>

            <div className='right'>
              <form ref={form} onSubmit={sendEmail}>
                <div className='f_flex center_align'>
                  <div className='input'>
                    <span>YOUR NAME</span>
                    <input className="inputEdit" type='text' name='your_name' placeholder="Your Name" />
                  </div>
                </div>
                <div className='input'>
                  <span>EMAIL </span>
                  <input className="inputEdit" type='email' name='your_email' placeholder="Your Email" />
                </div>
                <div className='input'>
                  <span>YOUR MESSAGE </span>
                  <textarea className="textAreaEdit" cols='30' rows='5' name='message' placeholder="Your Message"></textarea>
                </div>
                <button type="submit" value='send' className='btn_shadow'>
                  SEND MESSAGE <i className='fa fa-long-arrow-right'></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
